import { RefreshCcw, DownloadCloud } from "feather-icons-react/build/IconComponents";

export const certificateColumns = [
  {
    accessorKey: "Company Name",
    header: "Company Name",
    enableSorting: true,
  },
  {
    accessorKey: "Document Type",
    header: "Document Type",
    enableSorting: true,
    cell: ({ row }) => {
      const documentType = row.original["Document Type"];

      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-md font-medium bg-gray-100 text-gray-800">
          {documentType}
        </span>
      );
    },
  },
  {
    accessorKey: "Date Uploaded",
    header: "Date Uploaded",
    enableSorting: true,
  },
  {
    accessorKey: "Refreshed at",
    header: "Refreshed at",
    enableSorting: true,
  },
  {
    accessorKey: "Uploaded By",
    header: "Uploaded By",
    enableSorting: true,
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      return (
        <div className="flex space-x-2">
          <button
            onClick={() => row.original.handleRefresh(row.original)}
            className="text-gray-400 hover:text-gray-600"
            title="Refresh this certificate with updated data"
          >
            <RefreshCcw size={20} />
          </button>
          <button
            onClick={() => row.original.handleDownload(row.original)}
            className="text-gray-400 hover:text-gray-600"
            title="Download this certificate"
          >
            <DownloadCloud size={20} />
          </button>
        </div>
      );
    },
  },
];
